var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueDecorMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7978 23.9897H24.2012V47.9997H24.7978V23.9897Z",
    fill: "#919EA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4689 23.7231H0.5V24.3162H24.4689V23.7231Z",
    fill: "#919EA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1543 36.8741L11.6523 35.3811L23.7499 23.2534L25.2519 24.7464L13.1543 36.8741Z",
    fill: "#004669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7162 24.1941L24.3047 23.7851L36.32 11.7188L36.7315 12.1482L24.7162 24.1941Z",
    fill: "#919EA8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5007 25.053H23.4414V0H25.5605V22.9465H48.5007V25.053Z",
    fill: "#004669"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDecorMobile);
export default __webpack_public_path__ + "static/media/blue-decor-mobile.5e7330699ef831598892b3eefd34b974.svg";
export { ForwardRef as ReactComponent };